export default "__VITE_ASSET__D$92Xmk$__"